import type { UIMatch } from '@remix-run/react';
import { useMatches } from '@remix-run/react';
import { useIsomorphicLayoutEffect } from 'ahooks';
import type { APHandle } from '../type';

export const useScrollToHandle = (key: string, ele: HTMLDivElement | null) => {
    const matches = useMatches();

    const routeMatch = matches.find(
        (match) => match.handle && match.handle.hasOwnProperty('scrollTo')
    ) as UIMatch<unknown, APHandle> | undefined;

    // TODO: explore <ScrollRestoration> once we upgrade to remix 1.8x
    // https://github.com/remix-run/react-router/tree/main/examples/scroll-restoration

    useIsomorphicLayoutEffect(() => {
        const handleKey = routeMatch?.handle?.scrollTo;

        const shouldScroll = Boolean(handleKey && key === handleKey);

        if (!shouldScroll) return;
        if (!ele) return;

        ele.scrollIntoView();
    }, [ele, matches]);
};
